/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import { components } from '@glowingblue-orell-thalia-common';

const { HomeCategories } = components;
import type Mithril from 'mithril';

export default function () {
	extend(HomeCategories.prototype, 'listItem', function (vnode, category) {
		(vnode.children as Mithril.Vnode<any>[])[0].attrs.href = app.route.reviews_tag(category);
	});
}
